import React, { Fragment, useEffect, useState } from "react";
import {
  setActiveTabs,
  getv2AdditionalQuestion,
  getNextv2AdditionalQuestion,
  setQuestionValues,
  deleteQuestion,
  getSkillsList,
  getSkillsTopic,
  getCodingQuestions,
  getNextCodingQuestions,
  deleteCodingQuestion,
  resetCodingQuestions,
  getQuestionLevels,
  resetQuestions,
  resetQuestion,
} from "../../Redux/ActionCreators/testLibraryAction";
import {
  getSkills,
  getSkillTopics,
} from "../../Redux/ActionCreators/myTestsAction";
import "../My-assessment/myAssessment.scss";
import "../My-Questions/myQuestions.scss";
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ConfirmModal from "../../utils/confirmModal";
import { Box } from "@mui/material";
import Select from "react-select";
import MyTechnicalQuestions from "./myTechnicalQuestions";

const TABS_CONSTANTS = {
  MCQS: "MCQS",
  CODING: "CODING",
};

export default function MyQuestions() {
  const [page, setPage] = useState(1);
  const [codingPage, setCodingPage] = useState(1);
  const [query, setQuery] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [isConfirm, setIsConfirm] = useState(false);
  const [showSkillsTopic, setShowSkillsTopic] = useState(false);
  const [skill, setSkill] = useState("");
  const [topic, setTopic] = useState("");
  const [level, setLevel] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const details = JSON.parse(localStorage.getItem("profileDetails"));
  const [activeTab, setActiveTab] = useState(TABS_CONSTANTS.MCQS);
  const [activeTypeTab, setActiveTypeTab] = useState("General");
  const [testsPerPage, setTestsPerPage] = useState(10);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    questionLevel,
    active,
    isQuestionLoading,
    additionalQuestions,
    totalQues,
    skillType,
    skillTopic,
    loadingCodingQuestion,
    total,
    codingQuestionListResponse,
  } = useSelector((state) => state.testLibrary);
  const { skills, topics } = useSelector((state) => state.myTests);

  useEffect(() => {
    window.scrollTo(0, 0);
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
    setCodingPage(1);
    setPage(1);
    if (active === "MCQS") {
      dispatch(resetQuestions());
      setActiveTab("MCQS");
      {
        details?.tenentId === "-1" &&
          details?.roleId === "1" &&
          dispatch(getSkillsList(0));
      }
      details?.tenentId !== "-1" &&
        details?.roleId !== "1" &&
        dispatch(getSkills(2));
      dispatch(getQuestionLevels());
      dispatch(
        getv2AdditionalQuestion(
          "",
          skill?.value || 0,
          topic?.value || 0,
          level?.value || 0,
          0,
          page,
          testsPerPage
        )
      );
      // dispatch(getAdditionalQuestion(1, '', 1, testsPerPage, selectedskillId, selectedskillTopicId));
    } else {
      setActiveTab("CODING");
      dispatch(resetCodingQuestions());
      dispatch(getCodingQuestions(1, 20, 0, 0, "", []));
    }
  }, []);

  const handleTabChange = async (tab_name) => {
    setActiveTab(tab_name);
    setPage(1);
    setCodingPage(1);
    setSkill("");
    setTopic("");

    if (tab_name === TABS_CONSTANTS.MCQS) {
      await dispatch(resetQuestions());
      await dispatch(getv2AdditionalQuestion( "", skill?.value || 0, topic?.value || 0, level?.value || 0, 0, 1, testsPerPage));
    } else if (tab_name === TABS_CONSTANTS.CODING) {
      await dispatch(resetCodingQuestions());
      await dispatch(getCodingQuestions(1, 20, 0, 0, "", []));
    }
  };

  const paginateCodingQuestions = () => {
    setCodingPage(codingPage + 1);
    dispatch(getNextCodingQuestions(codingPage + 1, testsPerPage, 0, 0, query));
  };

  const timerRef1 = React.useRef(null);

  const searchQuestion = (val) => {
    clearTimeout(timerRef1.current);
    setPage(1);
    setQuery(val);
    timerRef1.current = setTimeout(() => delaySearch(val), 800);
  };

  const delaySearch = async (val) => {
    if (activeTab === TABS_CONSTANTS.CODING) {
      await dispatch(getCodingQuestions(1, 20, 0, 0, val, []));
    } else {
      await dispatch(resetQuestions());
      dispatch(
        getv2AdditionalQuestion(
          val,
          skill?.value || 0,
          topic?.value || 0,
          level?.value || 0,
          0,
          page,
          testsPerPage
        )
      );
      // await dispatch(getAdditionalQuestion(1, val, page, testsPerPage, selectedskillId, selectedskillTopicId));
    }
  };

  const handlePageSizeChange = async (e) => {
    const size = parseInt(e.target.value);
    setTestsPerPage(size);
    setCurrentPage(1);
    setPage(1);

    await dispatch(resetQuestions());
    dispatch(
      getv2AdditionalQuestion(
        query,
        skill?.value || 0,
        topic?.value || 0,
        level?.value || 0,
        0,
        1,
        size
      )
    );
  };

  const openCreate = async () => {
    await dispatch(resetQuestion());
    await dispatch(resetQuestions());
    await dispatch(resetCodingQuestions());
    await dispatch(setQuestionValues({ question: null }));
    navigate("/create", {
      state: { edit: false, question: true, detail: null, active },
    });
  };

  const editQuestion = async (el, view) => {
    await dispatch(setQuestionValues(el));
    navigate("/create", {
      state: { detail: el, edit: true, question: true, view: view },
    });
  };

  const viewEditCodingQuestion = async (el, view) => {
    await dispatch(resetQuestion());
    await dispatch(resetCodingQuestions());
    await dispatch(setQuestionValues(el));
    if (el?.questionTypeID === 12) {
      navigate("/create", {
        state: {
          detail: el,
          edit: true,
          question: true,
          view: view,
          questionTypeID: 12,
        },
      });
    } else if (el?.questionTypeID === 7) {
      navigate("/create", {
        state: {
          detail: el,
          edit: true,
          question: true,
          view: view,
          questionTypeID: 7,
        },
      });
    } else if (el?.questionTypeID === 13) {
      navigate("/create", {
        state: {
          detail: el,
          edit: true,
          question: true,
          view: view,
          questionTypeID: 13,
        },
      });
    } else {
      navigate("/create-coding-question", {
        state: { detail: el, edit: true, question: true, view: view },
      });
    }
  };

  const deleteQues = (id) => {
    setDeleteId(id);
    setIsConfirm(true);
  };

  const handleQuestionType = (tab) => {
    setActiveTypeTab(tab);
  };

  const removeConfirm = async () => {
    let obj = {
      questionID: deleteId,
    };
    const res = await dispatch(deleteQuestion(obj));
    if (res?.type === "DELETE_QUESTION") {
      setIsConfirm(false);
      setDeleteId("");
    }
  };
  const removeCodingQuestionOnConfirm = async () => {
    let req_obj = {
      id: deleteId,
    };
    const res = await dispatch(deleteCodingQuestion(req_obj));
    if (res?.type === "DELETE_QUESTION") {
      setIsConfirm(false);
      setDeleteId("");
      setCodingPage(1);
      dispatch(getCodingQuestions(1, testsPerPage, 0, 0, query, []));
    }
  };

  const onDeleteQuestionConfirmation = () => {
    if (activeTab === TABS_CONSTANTS.MCQS) {
      removeConfirm();
    }
    if (activeTab === TABS_CONSTANTS.CODING) {
      removeCodingQuestionOnConfirm();
    }
  };

  // * handle skill change
  const handleSkillChange = async (e) => {
    setLoading(true);
    setSkill(e);
    await dispatch(resetQuestions());
    await dispatch(
      getv2AdditionalQuestion(
        "",
        e?.value || 0,
        topic?.value || 0,
        level?.value || 0,
        0,
        1,
        testsPerPage
      )
    );
    try {
      const response =
        details?.tenentId === "-1" && details?.roleId === "1"
          ? await dispatch(getSkillsTopic(e.value))
          : await dispatch(getSkillTopics(2, e.value));
      // console.log("🚀 ~ handleSkillChange ~ response:", response)
      console.log(response);
      if (response.payload) {
        setLoading(false);
        setShowSkillsTopic(true);
        setTopic("");
      } else {
        console.log("\n Failed ", response);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error updating subscription:", error);
      setLoading(false);
    }
    console.log(showSkillsTopic);
  };

  // * handle skill topic change
  const handleSkillTopicChange = async (e) => {
    setTopic(e);
    await dispatch(resetQuestions());
    dispatch(
      getv2AdditionalQuestion(
        "",
        skill?.value || 0,
        e?.value || 0,
        level?.value || 0,
        0,
        page,
        testsPerPage
      )
    );
    // await dispatch(getAdditionalQuestion(1, '', page, testsPerPage, selectedskillId, selectedId));
  };

  const handleLevel = async (e) => {
    setLevel(e);
    await dispatch(resetQuestions());
    dispatch(
      getv2AdditionalQuestion(
        "",
        skill?.value || 0,
        topic?.value || 0,
        e?.value || 0,
        0,
        page,
        testsPerPage
      )
    );
    // await dispatch(getAdditionalQuestion(1, '', page, testsPerPage, selectedskillId, selectedId));
  };

  // Pagination logic
  const totalPages = Math.ceil(totalQues / testsPerPage);

  const paginate = async (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    setPage(pageNumber);
    await dispatch(resetQuestions());
    dispatch(
      getv2AdditionalQuestion(
        "",
        skill?.value || 0,
        topic?.value || 0,
        level?.value || 0,
        0,
        pageNumber,
        testsPerPage
      )
    );
  };

  const Pagination = ({ currentPage, totalPages, paginate }) => {
    const getPageNumbers = () => {
      if (totalPages <= 4) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      } else if (currentPage <= 3) {
        return [1, 2, 3, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        return [1, "...", totalPages - 2, totalPages - 1, totalPages];
      } else {
        return [
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages,
        ];
      }
    };
    return (
      <div className="pagination">
        <div className="d-flex flex-wrap align-items-center" style={{gap:'40px'}}>
          <div className="pagination-info">
            {additionalQuestions.length > 0 ? (
              <span>
                Showing <strong>{(currentPage - 1) * testsPerPage + 1}</strong>-
                <strong>
                  {(currentPage - 1) * testsPerPage + additionalQuestions.length}
                </strong>{" "}
                of <strong>{totalQues}</strong> questions
              </span>
            ) : (
              <span>Showing 0-0 of 0</span>
            )}
          </div>
          <div className="d-flex align-items-center">
            <span style={{ color: "#525B66" }}>Questions per page</span>
            &nbsp;&nbsp;
            <select
              value={testsPerPage}
              onChange={handlePageSizeChange}
              style={{ width: "46px", height:'32px', borderRadius:'2px', color:'#8A9199' }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
        </div>
        <div className="pagination-buttons">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <img src="/images/leftarrow-icon.svg" alt="" />
          </button>
          {getPageNumbers().map((page, index) => (
            <button
              key={index}
              onClick={() => (page === "..." ? null : paginate(page))}
              className={currentPage === page ? "active" : ""}
              disabled={page === "..."}
            >
              {page}
            </button>
          ))}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            <img
              src="/images/leftarrow-icon.svg"
              alt=""
              style={{ rotate: "180deg" }}
            />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="gappeo-my-tests">
      <div className="gappeo-my-tests-head">
        <h1>My Questions</h1>
      </div>
      <div className="tab-navigation">
        {["General", "Technical"].map((tab) => (
          <button
            key={tab}
            className={`tab-item ${activeTypeTab === tab ? "active" : ""}`}
            onClick={() => handleQuestionType(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      {activeTypeTab === "Technical" ? (
        <MyTechnicalQuestions />
      ) : (
        <div className="my-search">
          {details?.tenentId === "-1" &&
          details?.roleId === "1" &&
          activeTab === "MCQS" ? (
            <div className="row">
              <div className="col-md-6 col-12 select-wrapper">
                <Select
                  options={skillType?.map(
                    (el) => [{ label: el.skillName, value: el.skillId }][0]
                  )}
                  value={skill}
                  placeholder="Select Knowledge Area"
                  onChange={(e) => handleSkillChange(e)}
                />
              </div>
              {showSkillsTopic && skillTopic?.length > 0 ? (
                <div className="col-md-6 col-12 select-wrapper">
                  <Select
                    options={skillTopic?.map(
                      (el) =>
                        [
                          { label: el.skillTopicName, value: el.skillTopicId },
                        ][0]
                    )}
                    value={topic}
                    placeholder="Select Topic"
                    onChange={(e) => handleSkillTopicChange(e)}
                  />
                </div>
              ) : null}
            </div>
          ) : activeTab === "MCQS" ? (
            <div className="row">
              <div className="col-md-4">
                <div>
                  <Select
                    isClearable
                    options={skills}
                    value={skill}
                    placeholder="Select Knowledge Area"
                    onChange={(e) => handleSkillChange(e)}
                  />
                </div>
              </div>
              {/* <div className="col-md-4">
                <div>
                  <Select
                    isClearable
                    options={topics}
                    value={topic}
                    placeholder="Select Topic"
                    onChange={(e) => handleSkillTopicChange(e)}
                  />
                </div>
              </div> */}
              <div className="col-md-4">
                <div>
                  <Select
                    isClearable
                    options={questionLevel?.map(
                      (el) =>
                        [
                          {
                            label: el.questionLevelName,
                            value: el.questionLevelID,
                          },
                        ][0]
                    )}
                    value={level}
                    placeholder="Select Level"
                    onChange={(e) => handleLevel(e)}
                  />
                </div>
              </div>
            </div>
          ) : null}

          <div
            className="search-test  mt-3 flex-wrap d-flex justify-content-between gap-1"
            style={{
              alignItems: window.innerWidth < 767 ? "flex-start" : "center",
              flexDirection: window.innerWidth < 767 && "column-reverse",
            }}
          >
            <div
              className="has-search"
              style={{ width: window.innerWidth > 767 ? "79%" : "100%" }}
            >
              <span className="form-control-feedback">
                <img src="/images/search.svg" alt="" width={12} />
              </span>
              <input
                type="text"
                className="form-control"
                value={query}
                placeholder="Search for Question"
                onChange={(e) => searchQuestion(e.target.value)}
              />
            </div>
            <div style={{ width: window.innerWidth > 1000 ? "20%" : "100%" }}>
              <button
                  style={{ width: "-webkit-fill-available" }}
                  onClick={() => openCreate()}
                >
                  Create Question
                </button>
            </div>
          </div>
        </div>
      )}

      {activeTab === TABS_CONSTANTS.MCQS && activeTypeTab === "General" && (
        <div className="table-admin">
          <Table responsive className="assessment-table">
            <thead>
              <tr>
                <th className="text-left">Question</th>
                <th className="text-left">Type</th>
                <th className="text-left">Knowledge Area</th>
                <th className="text-left">Topic/Tags</th>
                <th className="text-left">View</th>
                <th className="text-left">Edit</th>
                <th className="text-left">Delete</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {isQuestionLoading ? (
                <tr>
                  <td colSpan="7">
                    <div className="loading-overlay" style={{alignItems:'start', color:'#F75891', height:'auto'}}>
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading questions...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : additionalQuestions?.length > 0 ? (
                additionalQuestions &&
                additionalQuestions?.map((el) => {
                  return (
                    <tr key={el?.questionID || el?.id}>
                      {window.innerWidth > 767 ? (
                        <Fragment>
                          <td style={{ width: "35%" }}>
                            <h5
                              className="elipsis-2"
                              dangerouslySetInnerHTML={{
                                __html: el?.question,
                              }}
                            />
                          </td>
                          <td style={{ width: "16%", textAlign: "left" }}>
                            <div>
                              {el?.questionTypeName === "Multiple Choice" ? (
                                <img src="/images/mcq.svg" alt="" width={20} />
                              ) : (
                                <img
                                  src="/images/essay.svg"
                                  alt=""
                                  width={20}
                                />
                              )}
                              <span> {el?.questionTypeName}</span>
                            </div>
                          </td>
                          <td style={{ width: "20%", textAlign: "left" }}>
                            <div>{el?.skillName}</div>
                          </td>
                          <td style={{ width: "20%", textAlign: "left" }}>
                            <div>{el?.skillTopicName}</div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <button
                                className="create"
                                onClick={() => editQuestion(el, true)}
                              >
                                View
                              </button>
                            </div>
                            {/* <img
                                  src="/images/view-icon-black.svg"
                                  width={16}
                                  className="cursor-pointer"
                                  alt=""
                                  onClick={() => editQuestion(el, true)}
                                /> */}
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <button
                                className="create"
                                onClick={() => editQuestion(el, false)}
                              >
                                Edit
                              </button>
                            </div>
                            {/* <img
                                  src="/images/edit-black-icon.svg"
                                  width={16}
                                  className="cursor-pointer"
                                  alt=""
                                  onClick={() => editQuestion(el, false)}
                                /> */}
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <button
                                className="create"
                                onClick={() => deleteQues(el.questionID)}
                              >
                                Delete
                              </button>
                            </div>
                            {/* <img
                                  src="/images/delete-icon.svg"
                                  width={16}
                                  height={16}
                                  className="cursor-pointer"
                                  onClick={() => deleteQues(el.questionID)}
                                  alt=""
                                /> */}
                          </td>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <td style={{ width: "75%" }}>
                            <h5
                              className="elipsis-2"
                              dangerouslySetInnerHTML={{
                                __html: el?.question,
                              }}
                            />
                            <div className="d-flex justify-content-start mt-2">
                              {el?.questionTypeName === "Multiple Choice" ? (
                                <img src="/images/mcq.svg" alt="" width={20} />
                              ) : (
                                <img
                                  src="/images/essay.svg"
                                  alt=""
                                  width={20}
                                />
                              )}
                              <span> {el?.questionTypeName}</span>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <button
                                className="create"
                                onClick={() => editQuestion(el, true)}
                              >
                                View
                              </button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <button
                                className="create"
                                onClick={() => editQuestion(el, false)}
                              >
                                Edit
                              </button>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <button
                                className="create"
                                onClick={() => deleteQues(el.questionID)}
                              >
                                Delete
                              </button>
                            </div>
                          </td>
                        </Fragment>
                      )}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="10">
                    <h3>No Questions added</h3>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            paginate={paginate}
          />
        </div>
      )}
      {activeTab === TABS_CONSTANTS.CODING && activeTypeTab === "General" && (
        <div className="table-admin">
          <div
            dataLength={
              (codingQuestionListResponse &&
                codingQuestionListResponse?.length) ||
              0
            }
            next={
              total > codingQuestionListResponse?.length
                ? paginateCodingQuestions
                : ""
            }
            hasMore={true}
          >
            {loadingCodingQuestion ? (
              <div className="gp-loader-container">
                <div className="gp-loader"></div>
              </div>
            ) : codingQuestionListResponse?.length > 0 ? (
              <Table responsive>
                <tbody className="table-body">
                  {codingQuestionListResponse &&
                    codingQuestionListResponse?.map((coding_question) => {
                      return (
                        <tr>
                          {window.innerWidth > 767 ? (
                            <Fragment>
                              <td style={{ width: "55%" }}>
                                <h5 className="elipsis-2">
                                  {coding_question?.name}
                                </h5>
                              </td>
                              <td style={{ textAlign: "left" }}>
                                <div>
                                  {coding_question?.questionTypeName ===
                                  "Multiple Choice" ? (
                                    <img
                                      src="/images/mcq.svg"
                                      alt=""
                                      width={20}
                                    />
                                  ) : (
                                    <img
                                      src="/images/essay.svg"
                                      alt=""
                                      width={20}
                                    />
                                  )}
                                  <span>
                                    {" "}
                                    {coding_question?.difficultyLevelName}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <button
                                    className="create"
                                    onClick={() =>
                                      viewEditCodingQuestion(
                                        coding_question,
                                        true
                                      )
                                    }
                                  >
                                    View
                                  </button>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <button
                                    className="create"
                                    onClick={() =>
                                      viewEditCodingQuestion(
                                        coding_question,
                                        false
                                      )
                                    }
                                  >
                                    Edit
                                  </button>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <button
                                    className="create"
                                    onClick={() =>
                                      deleteQues(coding_question?.id)
                                    }
                                  >
                                    Delete
                                  </button>
                                </div>
                              </td>
                            </Fragment>
                          ) : (
                            <Fragment>
                              <td style={{ width: "75%" }}>
                                <h5 className="elipsis-2">
                                  {coding_question?.name}
                                </h5>
                                <div className="d-flex justify-content-start mt-2">
                                  {coding_question?.questionTypeName ===
                                  "Multiple Choice" ? (
                                    <img
                                      src="/images/mcq.svg"
                                      alt=""
                                      width={20}
                                    />
                                  ) : (
                                    <img
                                      src="/images/essay.svg"
                                      alt=""
                                      width={20}
                                    />
                                  )}
                                  <span>
                                    {" "}
                                    {coding_question?.difficultyLevelName}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <button
                                    className="create"
                                    onClick={() =>
                                      viewEditCodingQuestion(
                                        coding_question,
                                        true
                                      )
                                    }
                                  >
                                    View
                                  </button>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <button
                                    className="create"
                                    onClick={() =>
                                      viewEditCodingQuestion(
                                        coding_question,
                                        false
                                      )
                                    }
                                  >
                                    Edit
                                  </button>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <button
                                    className="create"
                                    onClick={() =>
                                      deleteQues(coding_question?.id)
                                    }
                                  >
                                    Delete
                                  </button>
                                </div>
                              </td>
                            </Fragment>
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            ) : (
              <Box
                height="50vh"
                my={4}
                display="flex"
                flexDirection={"column"}
                alignItems="center"
                justifyContent="center"
                gap={4}
                p={2}
                sx={{ border: "2px solid grey" }}
              >
                <img src="/images/magnifier.svg" alt="" />
                <div className="mt-2">
                  <h3>Not found any coding question</h3>
                </div>
              </Box>
            )}
          </div>
        </div>
      )}

      <ConfirmModal
        isConfirm={isConfirm}
        setIsConfirm={() => setIsConfirm(false)}
        removeConfirm={onDeleteQuestionConfirmation}
      />
    </div>
  );
}
